import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Paper from '@mui/material/Paper';
import {
    List,
    Avatar,
    ListItem,
    ListItemText,
    Typography,
    ListItemSecondaryAction,
    ListItemAvatar,
    Divider,
    Link,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import { yellow, green, blueGrey, blue } from '@mui/material/colors';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import LabelIcon from '@mui/icons-material/Label';
import Button from '@mui/material/Button';
import CommuteIcon from '@mui/icons-material/Commute';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { statusFilter, summaryFilter, fleetSummarySelector, assetListSelector, setViewType } from '../../features/assets/assetsSlice';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: useTheme().spacing(1),
        },
    },
    small: {
        width: useTheme().spacing(3),
        height: useTheme().spacing(3),
    },
    inline: {
        display: 'inline',
    },
    yellow: {
        color: useTheme().palette.getContrastText(yellow[500]),
        backgroundColor: yellow[500],
    },
    green: {
        color: useTheme().palette.getContrastText(green[800]),
        backgroundColor: green[800],
    },
    grey: {
        color: useTheme().palette.getContrastText(blueGrey[500]),
        backgroundColor: blueGrey[500],
    },
    blue: {
        color: useTheme().palette.getContrastText(blue[500]),
        backgroundColor: blue[500],
    }

}));



const AssetSummaryList = () => {
    const classes = useStyles();
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const fleetSummary = useSelector(fleetSummarySelector);
    const assetList = useSelector(assetListSelector);
    const dispatch = useDispatch();

    const runStatusFiler = (type) => {
        dispatch(setViewType('filteredList'));
        dispatch(statusFilter(type));
        /*if (type !== 'No Data') {
            dispatch(statusFilter(type));
        }*/

    }

    const runSummaryFilter = (type) => {
        dispatch(setViewType('filteredList'));
        dispatch(summaryFilter(type));
    }


    return (
        <div style={{ ...dimentions.lowersidebar, overflow: 'auto', }}>
            <Paper elevation={3}>
                <List dense>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar className={classes.blue}><CommuteIcon /></Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <Fragment>
                                    <Typography variant="h6">Fleet Size</Typography>
                                </Fragment>
                            }
                            secondary={
                                <Button
                                    startIcon={<LabelIcon color="primary" />}
                                    size="small"
                                    disabled
                                >
                                    <span style={{ color: "dodgerblue" }}>
                                        {`${assetList.length} Vehicles`}
                                    </span>
                                </Button>
                            }
                        >
                        </ListItemText>
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    {
                        Object.keys(fleetSummary).map((summaryStatus, index) => (
                            <Fragment key={summaryStatus}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar className={classes[fleetSummary[summaryStatus].color]}>{fleetSummary[summaryStatus].count}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <Fragment>
                                                <Typography variant="h6">{summaryStatus}</Typography>
                                            </Fragment>
                                        }
                                        secondary={
                                            Object.keys(fleetSummary[summaryStatus].status).map((status, idx) => (
                                                <Fragment key={status}>
                                                    <Button
                                                        startIcon={<LabelOutlinedIcon color="primary" />}
                                                        size="small"
                                                        onClick={() => runStatusFiler(status)}
                                                    >
                                                        <span style={{ color: fleetSummary[summaryStatus].status[status].color }}>
                                                            {`${status}: ${fleetSummary[summaryStatus].status[status].count}`}
                                                        </span>
                                                    </Button>

                                                    <br />

                                                </Fragment>


                                            ))
                                        }
                                    >
                                    </ListItemText>
                                    <ListItemSecondaryAction>
                                        <Typography variant="subtitle2">
                                            <Link href='#' onClick={() => runSummaryFilter(summaryStatus)}>Show</Link>
                                        </Typography>

                                    </ListItemSecondaryAction>
                                </ListItem>
                                {
                                    index < Object.keys(fleetSummary).length - 1 && <Divider variant="inset" component="li" />
                                }

                            </Fragment>
                        )
                        )
                    }


                </List>
            </Paper>
        </div>
    );
}

export default React.memo(AssetSummaryList);